// 推广管理
import http from '@/jslibs/axios/http';

// 推广列表
export const list = data => http.get('/v1/cms/user/promotion_list', data);